// extracted by mini-css-extract-plugin
module.exports = {"scrollArrow":"NavigationArrow_scrollArrow__3uhQF","temporalScrollArrowContainer":"NavigationArrow_temporalScrollArrowContainer__qFzG-"};